import React from 'react'
import css from './style.scss'
import store from 'utils/store'
import api from './api'
import Formsy from 'formsy-react-2';
import Input from 'components/shared/input'
import Button from 'components/shared/button'
import CloseIcon from 'react-icons/lib/md/close'
import cn from 'classnames'
import {Link} from 'react-router-dom'
import {connect} from 'react-redux'

const TotalCollabSection=(props)=>{
  if(props.plan === "free"){
    return (
      <p className={cn(css.totalCollabs, css.noCollabsLeft)}>
        You are on the free plan. <Link to="/settings">Become pro</Link> to add some collaborators!
      </p>
    )
  }
  if(props.collabsLeft>0){
    return (
      <p className={css.totalCollabs}>
        You can still invite <b>{props.collabsLeft}</b> collaborators.
      </p>
    )
  }else{
    return (
      <p className={cn(css.totalCollabs, css.noCollabsLeft)}>
        You have reached the limit of Collaborators for your plan. <br/> <Link to="/settings">Do you want to upgrade?</Link>
      </p>
    )
  }
}

class Collaborator extends React.Component{
  removeCollaborator=()=>{
    
    if(window.confirm("Do you really want to remove this Collaborator?")){
      api.removeCollaborator(this.props.account, this.props.user).then(response=>{
        store.dispatch({type:"ADD_TOAST", message:"Collaborator removed."})
        let _account={}
        _account[response.id]=response
        store.dispatch({type:"ADD_ACCOUNT", payload:_account})
        this.props.onRemove()
      })
    }
  }
  render(){
    return (
      <div className={css.collaborator}>
      <div className={css.info}>
        {this.props.user.id && <div>{this.props.user.firstName} {this.props.user.lastName}</div>}
        {this.props.user.email && <div>{this.props.user.email}</div>}
      </div>
      <div className={css.remove} onClick={this.removeCollaborator}><CloseIcon size={20}/></div>
      </div>
    )
  }
}
class CollaboratorForm extends React.Component{
  constructor(props){
    super(props)
    this.state={
      enabled:false,
      email:""
    }
  }
  enableButton=()=>{
    this.setState({enabled:true})
  }
  disableButton=()=>{
    this.setState({enabled:false})
  }
  submit=(model)=>{
    model.role="collaborator"
    api.addCollaborator(this.props.account, model).then(response=>{
      let _account={}
      _account[response.account.id]=response.account
      switch(response.status){
        case "added":
          store.dispatch({type:"ADD_TOAST", message:"Collaborator added."})
          store.dispatch({type:"ADD_ACCOUNT", payload:_account})
          break;
        case 'invited':
          store.dispatch({type:"ADD_TOAST", message:"Collaborator invited."})
          store.dispatch({type:"ADD_ACCOUNT", payload:_account})
          break;
        case 'already_in':
          store.dispatch({type:"ADD_TOAST", message:"This collaborator has already access to this account."})
          break;
        default:
          return;
      }
      this.setState({email:""})
      this.props.onAdd()
    })
  }
  changeEmail=(e,v)=>{
    this.setState({email:v})
  }
  render(){
    ////console.log(!this.state.enabled)
    return (
      <Formsy.Form className={css.form} onValidSubmit={this.submit} onValid={this.enableButton} onInvalid={this.disableButton}>
        <div className={css.row}>
          <Input type="email" onChange={this.changeEmail} fullWidth={true} validations="isEmail" placeholder="Add collaborator..." required value={this.state.email} name="email"/>
          <Button fullWidth={true} disabled={!this.state.enabled} primary type="submit">Invite</Button>
        </div>
      </Formsy.Form>
    )
  }
}


class SettingsSection extends React.Component{
  constructor(props){
    super(props)
    this.state={
      collaboratorsNumber:0,
      collaborators:[]
    }
  }
  checkCollaborators=()=>{
    api.loadTotalCollaborators().then(response=>{
      this.setState({collaboratorsNumber:response.collaborators.length, collaborators:response.collaborators, collabsLeft: response.collaboratorsLeft})
    })
  }
  componentDidMount(){
    this.checkCollaborators()
  }
  render(){
    //console.log(this.props.user_plan)
    //const collabsLeft=planCollaborators[this.props.user_plan]-this.state.collaboratorsNumber
    return (
      <div className={css.collaborators_section}>
        <div className={css.head}>
          <h4>Collaborators</h4>
          {this.props.account.users.filter(u=>u.role!=="creator").map(u=><Collaborator onRemove={this.checkCollaborators} account={this.props.account.id} key={u.email} user={u}/>)}
          <TotalCollabSection collabsLeft={this.state.collabsLeft} plan={this.props.user_plan} collaborators={this.state.collaborators}/>
          {this.state.collabsLeft > 0 &&
            <CollaboratorForm onAdd={this.checkCollaborators} account={this.props.account}/>
          }
        </div>
      </div>
    )
  }
}

const mapStateToProps=(state)=>{
  return {
    user_plan:state.user.userData.subscription.plan
  }
}
export default connect(mapStateToProps)(SettingsSection);



// WEBPACK FOOTER //
// ./src/components/account_page/settings/collaborators.js